<template>
    
    <b-overlay :show="deleting">
        <template #overlay>
          <div class="text-center">
            <b-icon-x-square-fill font-scale="3" animation="throb" :variant="variant"></b-icon-x-square-fill>
            <p>{{ btntext }}ing...</p>
          </div>
        </template>

        <router-link class="event-link" :to="{ name: nextroute, params: { trackid: blogpost.track_id } }">
            <div class="event-card -shadow p-2 m-2"> 
                <img :src="blogpost.coverphoto" class="blog-image" :title="blogpost.title">
                <h3>Title : {{ blogpost.title }}</h3>
                <h5 class="title mt-1">Subtitle : {{ blogpost.subtitle }} </h5>
                <p>Written by : {{ blogpost.writer }}</p>
                <b-row>
                    <b-col cols="12">
                        <div>
                            <h6>Tags: <i>{{blogpost.tags }}</i> </h6> 
                        </div>
                    </b-col> 
                </b-row>
            </div>
        </router-link>
    </b-overlay>
</template>

<script>
import { mapActions } from "vuex";
export default {
    props: ["blogpost", "nextroute"],
    data() {
        return {
            deleting: false,
        };
    },
    created() {
        let mathjaxlink = this.environ == 'development' ? "http://localhost/quicktest/plugins/Mathjax/MathJax.js?config=MML_HTMLorMML" : "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=MML_HTMLorMML"

        window.MathJax = { MathML: { extensions: ["mml3.js", "content-mathml.js"]}};
        let externalScript = document.createElement('script')
        externalScript.setAttribute('src', mathjaxlink )
        document.head.appendChild(externalScript)

    },
    methods: {
        ...mapActions("admin", ["perfDelete", "fetchForQuestions"]),
        queDelete() {
            this.deleting = true;
            let action = "";
            if (this.question.is_deleted == "Yes") {
                action = "Undelete";
            } else {
                action = "Delete";
            }
            let delobj = {
                action,
                trackid: this.question.track_id,
            };
            //console.log(delobj);
            return this.perfDelete(delobj).then(() => {
                this.$emit("refetch")
                //this.fetchForQuestions();
                this.deleting = false;
                //console.log(response.data);
            });
        },
    },
    computed: {
        variant() {
            if (this.question.is_deleted == "Yes") {
                return "info";
            } else {
                return "danger";
            }
        },
        variant2() {
            if (this.question.available == "Premium") {
                return "warning";
            } else {
                return "primary";
            }
        },
        btntext() {
            if (this.question.is_deleted == "Yes") {
                return "Undelete";
            } else {
                return "Delete";
            }
        },

        btntext2() {
            if (this.question.available == "Premium") {
                return "Premium";
            } else {
                return "Free";
            }
        },
    },
};
</script>

<style scoped>
.icon {
    width: 25px;
    height: 25px;
    margin-right: 5px;
}

.event-card {
    transition: all 0.2s linear;
    cursor: pointer;
    background-color: lightgray;
    border-radius: 10px 10px;
}

.event-card:hover {
    transform: scale(1.01);
    box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2), 0 1px 15px 0 rgba(0, 0, 0, 0.19);
}

.event-link {
    color: black;
    text-decoration: none;
}
.topright{
  font-size: 20px;
  position: absolute;
  right: 30px;
}
.blog-image{
    width: 100%;
    height: 100%;
    max-height: 10rem;
}

@media screen and (max-width: 768px) {
    .qimage {
        width: 100%;
        height: 200px;
    }
}

@media screen and (min-width: 768px) {
    .qimage {
        width: 75%;
        height: 250px;
    }
}
</style>
